import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  data: [],
  detail: null,
};

export const medicineSlice = createSlice({
  name: 'medicine',
  initialState,
  reducers: {
    addMedicine: (state) => {
      state.loading = true;
      state.error = null;
    },
    getMedicine: (state) => {
      state.loading = true;
      state.error = null;
    },
    getOneMedicine: (state) => {
      state.loading = true;
      state.error = null;
    },
    successMedicine: (state, action) => {
      state.loading = false;
      state.error = null;
      state.data = Array.isArray(action.payload) ? action.payload : [];
    },
    successOneMedicine: (state, action) => {
      state.loading = false;
      state.error = null;
      state.detail = action.payload || null;
    },
    failedMedicine: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    removeMedicine: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateMedicine: (state) => {
      state.loading = true;
      state.error = null;
    },
  },
});

export const {
  addMedicine,
  getMedicine,
  getOneMedicine,
  successMedicine,
  successOneMedicine,
  failedMedicine,
  removeMedicine,
  updateMedicine,
} = medicineSlice.actions;

export default medicineSlice.reducer;
